import { render, staticRenderFns } from "./list-all.vue?vue&type=template&id=4531f222&"
import script from "./list-all.vue?vue&type=script&lang=js&"
export * from "./list-all.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports